<template>
    <div class="card">
        <div class="card-body mb-0 pb-0">
            <TabNavigation
                v-model="activeTab"
                :tabs="tabs"
                class="mb-2"
            />
            <RequestLogListing v-if="activeTab == 1" class="fade-in" />
            <errorLogListing v-if="activeTab == 2" class="fade-in" />
            <activityLogListing v-if="activeTab == 3" class="fade-in" />
            <communicationLogListing v-if="activeTab == 4" class="fade-in" />
            <ServedeckLogListing v-if="activeTab == 5" class="fade-in" />
        </div>
    </div>
</template>
<script>
import ServedeckLogListing from "@/views/pages/admin/diagnostic/servedeckLog/servedeckLogListing";
import TabNavigation from "@/components/customTopNav";
import RequestLogListing from "@/views/pages/admin/diagnostic/requestLog/requestLogListing";
import errorLogListing from "@/views/pages/admin/diagnostic/errorLog/errorLogListing";
import activityLogListing from "@/views/pages/admin/diagnostic/activityLog/activityLogListing";
import communicationLogListing from "@/views/pages/admin/diagnostic/communicationLog/communicationLogListing";

export default {
    components: { ServedeckLogListing, TabNavigation, RequestLogListing, errorLogListing, activityLogListing, communicationLogListing },
    data () {
        return {
            tabs: [
                { id: 1, name: 'Request Log', icon: 'mdi-web', count: null },
                { id: 2, name: 'Error Log', icon: 'mdi-console', count: null },
                { id: 3, name: 'Activity Log', icon: 'mdi-file-clock-outline', count: null },
                { id: 4, name: 'Communication Log', icon: 'mdi-message-text-outline', count: null },
                { id: 5, name: 'Servedeck Log', icon: 'mdi-server-network', count: null },
            ],
            activeTab: 1,
        };
    },
}
</script>